import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import ManchesterFooter from "@/pages/manchester/ManchesterFooter";
import AdminStatsWidget from "@/components/AdminStatsWidget";
import PromoBar from "@/components/PromoBar";
import { trackPageView, pageKeyFromPath } from "@/lib/pageTracking";

export default function SiteLayout() {
  const location = useLocation();

  useEffect(() => {
    const page = pageKeyFromPath(location.pathname);
    return trackPageView(page);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <PromoBar />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <ManchesterFooter />
      <AdminStatsWidget />
    </div>
  );
}